(() => {
  const popup = document.getElementById('HosteccoWelcomePopup');
  if (!popup) return;

  const dialog = popup.querySelector('[role="dialog"]');
  const closeButtons = popup.querySelectorAll('[data-welcome-close]');
  const success = popup.querySelector('[data-welcome-subscribed]');
  const storage = {
    closed: 'hostecco_welcome_closed_at',
    subscribed: 'hostecco_welcome_subscribed'
  };
  const sevenDays = 7 * 24 * 60 * 60 * 1000;
  let chatPreviousVisibility = '';

  const hideChat = () => {
    const chat = document.querySelector('shopify-chat');
    if (!chat) return;
    chatPreviousVisibility = chat.style.visibility;
    chat.style.visibility = 'hidden';
  };

  const restoreChat = () => {
    const chat = document.querySelector('shopify-chat');
    if (!chat) return;
    chat.style.visibility = chatPreviousVisibility;
  };

  const show = () => {
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hostecco-welcome-open');
    hideChat();
    window.setTimeout(() => dialog?.focus(), 0);
  };

  const close = () => {
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hostecco-welcome-open');
    restoreChat();
    try {
      localStorage.setItem(storage.closed, String(Date.now()));
    } catch (error) {}
  };

  closeButtons.forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) close();
  });

  if (success) {
    try {
      localStorage.setItem(storage.subscribed, 'true');
    } catch (error) {}
    show();
    return;
  }

  try {
    if (localStorage.getItem(storage.subscribed) === 'true') return;
    const lastClosed = Number(localStorage.getItem(storage.closed) || 0);
    if (lastClosed && Date.now() - lastClosed < sevenDays) return;
  } catch (error) {}

  window.setTimeout(show, 12000);
})();
